export default {
  masterChef: {
    97: '0x3950d1056eb2d9e7004cd89e2a5adc9918b55289',
    56: '0x3950d1056eb2d9e7004cd89e2a5adc9918b55289',
  },
  sousChef: {
    97: '0xe642f841698f175226f83471cb601685b6b5387f',
    56: '0xe642f841698f175226f83471cb601685b6b5387f',
  },
  lotteryV2: {
    97: '0x5790c3534F30437641541a0FA04C992799602998',
    56: '0x5aF6D33DE2ccEC94efb1bDF8f92Bd58085432d2c',
  },
  multiCall: {
    56: '0x942e01b7c75b67d49ea5a0a68d443b0e0215898b',
    97: '0x942e01b7c75b67d49ea5a0a68d443b0e0215898b',
  },
  pancakeProfile: {
    56: '0x05d7164e11a2fbf94faeaba0fe15f1b2d5c42125',
    97: '0x05d7164e11a2fbf94faeaba0fe15f1b2d5c42125',
  },
  pancakeRabbits: {
    56: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    97: '0x2aF3F613ffEEa872F12b068C60cfa355f7A7bdb8',
  },
  bunnyFactory: {
    56: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    97: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
  },
  claimRefund: {
    56: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    97: '0x198f412514dcb25737f6a56bbeb903169da34f8e',
  },
  pointCenterIfo: {
    56: '0x64b8518af61ee3f30c67f18ad80b86b3e17a71ab',
    97: '0x64b8518af61ee3f30c67f18ad80b86b3e17a71ab',
  },
  bunnySpecial: {
    56: '0xFee8A195570a18461146F401d6033f5ab3380849',
    97: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
  },
  tradingCompetition: {
    56: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    97: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97',
  },
  easterNft: {
    56: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    97: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
  },
  cakeVault: {
    56: '0xfae81df36cb997f574a9a887631d6e0871caf2ef',
    97: '0xfae81df36cb997f574a9a887631d6e0871caf2ef',
  },
  predictions: {
    56: '0x18B2A687610328590Bc8F2e5fEdDe3b582A49cdA',
    97: '0xF640DD4Fe9C51dE038516493f1e857F9De9B60Bd',
  },
  chainlinkOracle: {
    56: '0xD276fCF34D54A926773c399eBAa772C12ec394aC',
    97: '0x1E428BA125A7D842B561D2848b69cc7d74465995',
  },
  bunnySpecialCakeVault: {
    56: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    97: '0x58a654208BF3eA80f3DB4BdbE3327eb709F615B0',
  },
  bunnySpecialPrediction: {
    56: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    97: '0x5F68C89f9EF5F3cf48b7e3fb4669e56c030D2ceb',
  },
  bunnySpecialLottery: {
    56: '0x24ED31d31C5868e5a96aA77fdcB890f3511fa0b2',
    97: '0x382cB497110F398F0f152cae82821476AE51c9cF',
  },
  farmAuction: {
    56: '0xb92Ab7c1edcb273AbA24b0656cEb3681654805D2',
    97: '0x3F9602593b4f7C67ab045DB51BbDEa94E40fA9Fe',
  },
  AnniversaryAchievement: {
    56: '0x787980da5491118C3cB33B21aB50c8c379D2C552',
    97: '0x56D91898b0682FB7e91a4c08EaD7d3dbCb24291D',
  },
  nftMarket: {
    56: '0x17539cCa21C7933Df5c980172d22659B8C345C5A',
    97: '0x56D91898b0682FB7e91a4c08EaD7d3dbCb24291D',
  },
  nftSale: {
    56: '0x29fE7148636b7Ae0b1E53777b28dfbaA9327af8E',
    97: '0xe486De509c5381cbdBF3e71F57D7F1f7570f5c46',
  },
  pancakeSquad: {
    56: '0x0a8901b0E25DEb55A87524f0cC164E9644020EBA',
    97: '0xbEdd28Dd14D7A3C22b7380c6eBFB431aa9153119',
  },
}
